import React, { useEffect, useState, useRef } from "react";
import { UserRound } from "lucide-react";
import "../css/ParentTestimonials.css";

const ParentTestimonials = () => {

  const testimonials = [
    {
      id: 1,
      text: "Sahara Public Secondary School is a fantastic school. The teachers are professional, caring, dedicated, and well-organized. The following words are too small to say thank you. 'I am very happy for my child is well looked after in school and learns a lot of things everyday.' I am pleased with my child's progress due to helping teachers and staff.",
      author: "Mr. Adit M Gandhi",
      relation: "Father of Pushti Adit Gandhi",
    },

    {
      id: 2,
      text: "I am really glad that my daughter is admitted to Sahara Public Secondary School. The teachers are very cooperative and are professionally sound to handle all the children academically. Going one step further, I feel the education given here has a holistic approach. I would rather say, that the honorable Principal and Teachers are giving their best.",
      author: "Mr. Savio Fernandez",
      relation: "Father of Zoe Fernandez",
    },

    {
      id: 3,
      text: "I am pleased with the way classes are happening even in challenging times. Through innovative classrooms, not only my ward can continue academics smoothly and safely, but various scholastic and co-scholastic activities (like speaking activities, lifeskills class, dance and yoga, art & craft classes) also help in character development.",
      author: "Ms. Parul Gupta",
      relation: "Mother of Hardik Jaiswal",
    },

    {
      id: 4,
      text: "The infrastructure, discipline, and attention to detail given by the coordinators are exceptional. My son loves going to the school daily and has shown amazing progress in active communication and public speaking.",
      author: "Mr. Ramesh Shrestha",
      relation: "Father of Aarav Shrestha",
    },
  ];


  const [doubleTestimonials] = useState([
    ...testimonials,
    ...testimonials
  ]);


  const sliderRef = useRef(null);


  useEffect(() => {

    const slider = sliderRef.current;

    if (!slider) return;


    let animationFrameId;
    let scrollAmount = 0;

    const speed = 1;


    const scrollLoop = () => {

      scrollAmount += speed;


      if(scrollAmount >= slider.scrollWidth / 2){
        scrollAmount = 0;
      }


      slider.scrollLeft = scrollAmount;


      animationFrameId = requestAnimationFrame(scrollLoop);

    };


    animationFrameId = requestAnimationFrame(scrollLoop);



    const handleMouseEnter = () => {
      cancelAnimationFrame(animationFrameId);
    };


    const handleMouseLeave = () => {
      animationFrameId = requestAnimationFrame(scrollLoop);
    };


    slider.addEventListener(
      "mouseenter",
      handleMouseEnter
    );


    slider.addEventListener(
      "mouseleave",
      handleMouseLeave
    );



    return () => {

      cancelAnimationFrame(animationFrameId);


      slider.removeEventListener(
        "mouseenter",
        handleMouseEnter
      );


      slider.removeEventListener(
        "mouseleave",
        handleMouseLeave
      );

    };


  }, [doubleTestimonials]);




  return (

    <section className="testimonials-slider-section">


      <h2 className="slider-main-heading">
        Hear what parents have to say about us
      </h2>



      <div className="decor-quote-mark">
        “
      </div>



      <div
        className="slider-window-track"
        ref={sliderRef}
      >


        <div className="slider-cards-flexbox">


          {
            doubleTestimonials.map((item,index)=>(


              <div
                key={`${item.id}-${index}`}
                className="testimonial-slide-card"
              >



                {/* Human Icon */}

                <div className="parent-avatar-box">

                  <UserRound className="parent-human-icon"/>

                </div>




                {/* Parent Review */}

                <p className="parent-opinion-text">
                  {item.text}
                </p>





                {/* Parent Details */}

                <div className="parent-identity-footer">


                  <h4 className="parent-name-head">
                    {item.author}
                  </h4>


                  <p className="parent-sub-relation">
                    {item.relation}
                  </p>


                </div>



              </div>


            ))
          }


        </div>


      </div>


    </section>

  );

};


export default ParentTestimonials;